export default __webpack_public_path__ + "static/yoshie2019-50b567f8fec68e1b443b3a590c31dd8a.png";